import { Injectable, inject } from '@angular/core';
import { ApiService, PhotographerService, PhotographyVendor } from '@lc/core';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { PhotoAppProvider } from './models/photo-app-provider.model';

@Injectable({ providedIn: 'root' })
export class PhotoAppProvidersService {
  private readonly api = inject(ApiService);
  private readonly photographerService = inject(PhotographerService);

  list$() {
    return this.api.get<{ items: PhotographyVendor[]; legacyAgencyIds: string[]; isStaff: boolean }>('photography/vendors').pipe(
      switchMap(({ items, legacyAgencyIds, isStaff }) => {
        const agencies$ = isStaff || legacyAgencyIds.length ? this.photographerService.retrievePhotographers() : of([]);
        return agencies$.pipe(map((agencies) => {
          const providers: PhotoAppProvider[] = items.map((vendor) => {
            const legacyAgencies = vendor.mongoId === null ? [] : agencies.filter((agency) => String(agency.code) === vendor.mongoId);
            return {
              id: vendor.vendorId,
              ids: [vendor.vendorId, ...legacyAgencies.map((agency) => agency._id)],
              title: vendor.name,
              thumbnailUri: vendor.logoImage ?? legacyAgencies[0]?.thumbnailUri,
            };
          });
          const groupedIds = new Set(providers.flatMap((provider) => provider.ids));
          return [...providers, ...agencies.filter((agency) => !groupedIds.has(agency._id)).map((agency) => ({
            id: agency._id, ids: [agency._id], title: agency.title, thumbnailUri: agency.thumbnailUri,
          }))];
        }));
      }),
    );
  }
}
